export default __webpack_public_path__ + "static/527-9cb0a8931751755e83972117ed833fd4.gif";